// material-ui
import { Typography } from '@mui/material';
import { useMemo } from 'react';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import menuTechnical from 'menu-items/menuTechnical';
import { useSelector } from 'react-redux';
import menuManager from 'menu-items/menuManager';
import menuSupervisor from 'menu-items/menuSupervisor';
import menuVi from 'menu-items/meuVi';
import menuColeta from 'menu-items/menuColeta';
import { canAccessKpiMenu } from 'views/pages/Kpi/kpiUtils';
import { canAccessTechnicianMap } from 'views/pages/TechnicianMap/technicianMapUtils';

const filterRestrictedMenus = (groups, user) =>
    (groups || []).map((group) => ({
        ...group,
        children: (group.children || []).filter((item) => {
            if (item.id === 'kpis') return canAccessKpiMenu(user);
            if (item.id === 'technician_map') return canAccessTechnicianMap(user);
            return true;
        })
    }));

// ==============================|| SIDEBAR MENU LIST ||============================== //
const MenuList = () => {
    const user = useSelector((state) => state.auth.user);
    const id_role = user?.perfil_id;
    const supervisor = user?.supervisor;

    const nav = useMemo(() => {
        if (!id_role) {
            return null;
        }
        if (id_role === 3) {
            if (supervisor == 1) {
                return menuSupervisor;
            }
            return menuTechnical;
        }
        if (id_role === 4) {
            return menuManager;
        }
        if (id_role === 7) {
            return menuVi;
        }
        if (id_role === 8) {
            return menuColeta;
        }
        return menuItem;
    }, [id_role, supervisor]);

    const navItems = useMemo(() => {
        if (!nav) {
            return null;
        }
        const groups = filterRestrictedMenus(nav.items, user);
        return groups.map((item) => {
            switch (item.type) {
                case 'group':
                    return <NavGroup key={item.id} item={item} />;
                default:
                    return (
                        <Typography key={item.id} variant="h6" color="error" align="center">
                            Menu Items Error
                        </Typography>
                    );
            }
        });
    }, [nav, user]);

    if (!id_role) {
        return null;
    }

    return <>{navItems}</>;
};

export default MenuList;
